import { Swap } from '@velocity-exchange/icons';
import { CollateralInputV2 } from 'src/components/Inputs/CollateralInput';
import { InputQuickActions } from 'src/components/Inputs/InputQuickActions';
import IconButton from 'src/components/primitives/IconButton/IconButton';
import { SpotMarketConfig } from '@velocity-exchange/sdk';
import { BigNum } from '@velocity-exchange/sdk';

interface Props {
	swapFromAmount: string;
	handleSwapFromAmountUserChange: (value: string | undefined) => void;
	swapToAmount: string;
	handleSwapToAmountUserChange: (value: string | undefined) => void;
	swapFromMarket: SpotMarketConfig;
	handleFromMarketChange: (market: SpotMarketConfig) => void;
	swapToMarket: SpotMarketConfig;
	handleToMarketChange: (market: SpotMarketConfig) => void;
	fromTokenBalance: BigNum;
	maxSwapSize: BigNum;
	fromTokenPrice: number;
	toTokenPrice: number;
	reverseTokenPair: () => void;
	currentUserKey: string | undefined;
	poolId: number;
}

export default function SwapFormInputs({
	swapFromAmount,
	handleSwapFromAmountUserChange,
	swapToAmount,
	handleSwapToAmountUserChange,
	swapFromMarket,
	handleFromMarketChange,
	swapToMarket,
	handleToMarketChange,
	fromTokenBalance,
	maxSwapSize,
	fromTokenPrice,
	toTokenPrice,
	reverseTokenPair,
	currentUserKey,
	poolId,
}: Props) {
	return (
		<div className="relative flex flex-col gap-y-sm">
			<CollateralInputV2
				label="Pay"
				value={swapFromAmount}
				onChangeValue={handleSwapFromAmountUserChange}
				maxAmount={maxSwapSize}
				selectedMarket={swapFromMarket}
				onChangeMarket={handleFromMarketChange}
				source={{ type: 'userAccount', userKey: currentUserKey }}
				poolId={poolId}
				customElementRight={
					fromTokenBalance.gt(BigNum.zero()) ? (
						<InputQuickActions.CustomButton
							onClick={() =>
								fromTokenBalance.gt(BigNum.zero())
									? handleSwapFromAmountUserChange(fromTokenBalance.print())
									: undefined
							}
							label={`Your Position: ${fromTokenBalance.prettyPrint(true)}`}
						/>
					) : undefined
				}
				subValue={`~${(fromTokenPrice * (+swapFromAmount || 0)).toFixed(2)}`}
			/>
			<IconButton
				size="md"
				className="absolute top-1/2 right-1/2 translate-x-1/2 -translate-y-1/2 bg-container-bg text-text-secondary [&_svg]:rotate-90"
				variant="primary"
				icon={Swap}
				onClick={reverseTokenPair}
			/>
			<CollateralInputV2
				label="Receive"
				value={swapToAmount}
				onChangeValue={handleSwapToAmountUserChange}
				maxAmount={maxSwapSize}
				selectedMarket={swapToMarket}
				onChangeMarket={handleToMarketChange}
				source={{ type: 'userAccount', userKey: currentUserKey }}
				poolId={poolId}
				subValue={`~${(toTokenPrice * (+swapToAmount || 0)).toFixed(2)}`}
			/>
		</div>
	);
}
